<template>
  <section class="font-gothamr h-auto md:h-screen bg-no-repeat bg-top w-full xl:overflow-hidden">
    <div>
      <div v-if="!isActive" class="h-screen flex justify-center items-center flex-col">
        <img class="mb-3" src="https://ieltsmentor.edu.vn/wp-content/uploads/2023/10/image-10.png" alt="">
        <h3 class="text-xl text-center">Hiện tại không có chương trình quay thưởng nào đang diễn ra.</h3>
      </div>
      <div v-else class="relative">
        <div class="grid md:grid-cols-1 md:gap-4 lg:grid-cols-2">
          <div class="relative min-h-[800px] max-h-screen bg-cover bg-center md:bg-none md:min-h-screen">
            <div class="absolute left-0 right-0 top-16 flex justify-center items-end md:mx-0 mx-12">
              <img class="hidden absolute top-[-20px] right-0 h-[90px] xl:block" src="@/assets/images/bird-center.png" alt="" />
              <img class="w-[340px] md:block md:w-[580px] object-cover" src="@/assets/images/top-spin.png" alt="" />
            </div>
            <div class="box-wheel overflow-hidden absolute left-0 top-[200px] right-0 bottom-52 h-[550px] md:h-[650px] md:top-[350px] xl:top-[320px]">
              <div class="absolute flex justify-center bottom-[50px] left-0 right-0 z-[10] h-[400px] md:top-0 md:h-[550px] md:bottom-0">
                <img class="h-[400px] md:h-[550px]" src="@/assets/images/spin.png" alt="">
              </div>
              <div class="absolute z-20 inset-0 flex justify-center items-center">
                <div @click="startSpin()" class="mb-[10px] w-14 h-14 z-20 cursor-pointer rounded-full md:w-20 md:h-20 md:mb-[180px]"></div>
              </div>
              <el-button
                  @click="dialogLogin = true" v-if="!is_login"
                  class="text-black px-4 cursor-pointer border border-black absolute bottom-0 left-1/2 -translate-x-1/2 z-[30] md:px-7 xl:bottom-10"
                  type="text"
              >
                Đăng nhập
              </el-button>
              <div class="z-10 flex items-center justify-center h-[400px] md:h-[550px]">
                <canvas class="mt-[140px] md:mt-[-70px]" id='canvas' :width="isMobile() === 320 ? 320 : 450"
                        :height="isMobile() === 320 ? 320 : 450">
                  Canvas not supported, use another browser.
                </canvas>
              </div>
              <div class="absolute top-0 left-[10px] h-[130px] md:h-[150px] z-[100] lg:top-28 lg:left-16">
                <img class="h-[130px] md:h-[150px]" src="@/assets/images/paper-left.png" alt="">
              </div>
              <div class="z-[100] absolute top-0 right-4 h-[150px] md:h-[200px] lg:h-[250px]">
                <img class="h-[150px] md:h-[200px] lg:h-[250px]" src="@/assets/images/laptop.png" alt="">
              </div>
              <div class="z-[100] absolute bottom-0 left-0 h-[50px] md:h-[100px] xl:hidden">
                <img class="h-[50px] md:h-[100px]" src="@/assets/images/bird-right.png" alt="">
              </div>
              <div class="z-[100] absolute bottom-4 right-[-30px] h-[130px] md:h-[150px] xl:h-[180px]">
                <img class="h-[130px] md:h-[150px] xl:h-[180px]" src="@/assets/images/paper-center.png" alt="">
              </div>
            </div>
          </div>
          <div class="h-full flex flex-col gap-3 px-6 pb-20 md:px-10 md:pt-16 xl:pr-20 xl:h-screen">
            <HistoryGift class="flex-grow" @history="is_history = true" @myGift="is_history = false"
                         :is-history="is_history" :is-login="is_login" :data-gift="dataGift"
                         :data-table="dataHistory" :is-mobile="mobileScreen"/>
            <NoteComponent :is-mobile="mobileScreen" :is-login="is_login"/>
          </div>
        </div>
        <div class="absolute top-0 left-0 right-0 h-fit flex justify-end items-center">
          <div class="mt-2 mr-2">
            <div class="flex items-center">
              <div class="lg:flex mr-4 text-black" v-text="'Xin chào, ' + query.name" v-if="is_login"></div>
              <el-button @click="logout" v-if="is_login" v-text="'Đăng xuất'" class="text-black cursor-pointer border" type="warning"></el-button>
            </div>
          </div>
        </div>
      </div>
      <el-dialog :width="isMobile() === 320 ? '300px' : '768px'" :visible.sync="dialogLogin" title="Đăng nhập">
        <template #default>
          <div class="dialog-input" style="line-height: 30px;">
            <div class="inputn_phone">
              <div class="col-xxl-3 col-md-4">
                <label>
                  <b>Số điện thoại</b><span class="ml-2" style="color:red">*</span>
                </label>
                <div class="form-group w-100">
                  <el-input class="shadow-sm" type="text" v-model="query.phone"
                            clearable placeholder="Nhập số điện thoại" @input="debounceCheckPhone"
                  />
                </div>
                <p v-if="query.phone === '' && checkValidate" style="color: red">Số điện thoại không được để trống</p>
                <p v-if="errorPhone" class="text-red-500 break-words">Số điện thoại chưa được đăng ký quay thưởng. Vui lòng liên hệ tư
                  vấn viên để được hỗ trợ đăng ký.</p>
              </div>
            </div>
            <div class="col-xxl-3 col-md-4">
              <label class="mb-2">
                <b>Họ và tên</b>
              </label>
              <div class="form-group w-100">
                <el-input
                    :disabled="true" class="shadow-sm" type="text"
                    v-model="query.name" clearable placeholder="Nhập họ và tên"
                ></el-input>
              </div>
              <p v-if="query.name === '' && checkValidate" style="color: red">Họ và tên không được để trống</p>
            </div>
          </div>
        </template>
        <template #footer>
          <div class="dialog-footer text-center">
            <el-button :disabled="disabledSubmit" @click="login">Đăng nhập</el-button>
          </div>
        </template>
      </el-dialog>
      <el-dialog :width="isMobile() === 320 ? '300px' : '600px'" class="rounded-md" :visible.sync="centerDialogVisible"
                 center>
        <h3 class=" text-black text-center text-2xl pt-4 mb-6 break-normal">Chúc mừng bạn đã nhận được </h3>
        <div class="flex flex-col mb-5 justify-center items-center">
          <img class="w-1/3 mb-6" :src="image_url" alt="gift-img">
          <h3 class="text-lg text-black " v-text="listGift[index]?.name"></h3>
        </div>
        <template #footer>
          <span class="dialog-footer">
            <el-button @click="centerDialogVisible = false">Đóng</el-button>
          </span>
        </template>
      </el-dialog>

    </div>
  </section>
</template>

<script>

import moment from 'moment';
import * as Winwheel from "@/assets/js/Winwheel";
import NoteComponent from "@/pages/version2/components/NoteComponent.vue";
import HistoryGift from "@/pages/version2/components/HistoryGift.vue";
import bgWeb from "@/assets/images/bg-web.png"
import bgMb from "@/assets/images/bg-mb.png"

let URL_API_EDUTALK = process.env.VUE_APP_API_URL;
let GET_GIFT = 'v2/spin/customer-history/spin';
let GET_GIFT_LIST = 'v2/spin/get-gifts';
let GET_TURNS = 'v2/spin/check-turns';
let CHECK_PHONE_USER = 'v2/spin/check-user';
let GET_LIST_CLASS = 'v2/spin/get-class';
let GET_MY_GIFT = 'v2/spin/customer-history/get-spin-history-by-phone';
let GET_HISTORY_GIFT = 'v2/spin/customer-history';
let INFORMATION_SPIN = 'v2/spin/get-time-reward-program'
let GET_NAME_USER = 'v2/spin/customers/get-customer-by-phone'
const _ = require('lodash');

export default {
  name: 'VongQuay',
  components: {HistoryGift, NoteComponent},
  data() {
    return {
      dataHistory: [],
      dataGift: [],
      is_history: true,
      is_login: false,
      centerDialogVisible: false,
      theWheel: null,
      wheelPower: 0,
      wheelSpinning: false,
      audio: null,
      left_turns: 1,
      image_url: '',
      dialogLogin: false,
      query: {
        phone: '',
        name: '',
      },
      timeOut: null,
      listClass: [],
      errorPhone: false,
      checkValidate: false,
      listGift: [],
      index: -1,
      startDate: '',
      endDate: '',
      idProgram: null,
      checkDisable: false,
      isActive: false,
      baseUrlImage: 'https://ieltsmentor.edu.vn/wp-content/uploads/2024/12/',
      bgMobile: bgMb,     // Đặt trong thư mục `public/images`
      bgDesktop: bgWeb,
      disabledSubmit: true
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    mobileScreen() {
      if (window.innerWidth <= 1024) {
        document.body.classList.add('mobile')
        return true
      } else {
        document.body.classList.add('bg-desktop')
      }
    }
  },
  async mounted() {
    await this.getHistoryGift()
    await this.getMyGift()
    let phone = localStorage.phone ?? '';
    let class_id = localStorage.classroom ?? '';
    let name = localStorage.name ?? ''
    if (phone !== '') {
      this.is_login = true
    }
    const response = await fetch(`${URL_API_EDUTALK}/${GET_GIFT_LIST}`);
    const gift_list = await response.json();
    if (gift_list.data != null) {
      this.isActive = true;
      let data_gift = gift_list.data ?? [];
      this.listGift = data_gift;
      let result = data_gift.map((value, key) => {
        return {
          'fillStyle': key % 2 === 0 ? "#fff" : "#DE0927",
          'text': value.name,
          'textFillStyle': key % 2 === 0 ? "#DE0927" : "#fff"
        }
      })
      let length = data_gift.length;
      const res_turns = await fetch(`${URL_API_EDUTALK}/${GET_TURNS}?phone=${phone}&class_id=${class_id}`);
      const turns = await res_turns.json();
      let data_turns = turns.data;
      this.left_turns = this.left_turns - data_turns;
      const res_list_class = await fetch(`${URL_API_EDUTALK}/${GET_LIST_CLASS}`);
      const data_list_class = await res_list_class.json();
      this.listClass = data_list_class.data
      const res_time_program = await fetch(`${URL_API_EDUTALK}/${INFORMATION_SPIN}?class_id=${class_id}`);
      const data_time_program = await res_time_program.json();
      this.idProgram = data_time_program.data.id
      this.startDate = moment(data_time_program?.data?.start_date).format('DD/MM/YYYY')
      this.endDate = moment(data_time_program?.data?.end_date).format('DD/MM/YYYY')
      const response_name = await fetch(`${URL_API_EDUTALK}/${GET_NAME_USER}?phone=${phone}`);
      let data_name = await response_name.json()
      this.query.name = data_name?.data?.name
      this.audio = new Audio('https://ieltsmentor.edu.vn/wp-content/uploads/2023/10/tick.mp3');
      let width = 160;
      let textMargin = 25;
      let textFontSize = 12;
      if (/Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        width = 160;
        textMargin = 10;
        textFontSize = 10;
      }
      if (window.innerWidth >= 768) {
        width = 225;
        textMargin = 25;
        textFontSize = 14;
      }
      this.theWheel = new Winwheel.Winwheel({
        'outerRadius': width,        // Set outer radius so wheel fits inside the background.
        'innerRadius': 10,         // Make wheel hollow so segments don't go all way to center.
        'textFontSize': textFontSize,         // Set default font size for the segments.
        'lineWidth': 0.1,
        'textAlignment': 'center',
        'textMargin': textMargin,
        'numSegments': length,         // Specify number of segments.
        'segments': result,
        'animation':           // Specify the animation to use.
            {
              'type': 'spinToStop',
              'duration': 10,
              'spins': 3,
              'callbackFinished': this.alertPrize,  // Function to call whent the spinning has stopped.
              'callbackSound': this.playSound,   // Called when the tick sound is to be played.
              'soundTrigger': 'pin'        // Specify pins are to trigger the sound.
            },

      });
    }
  },
  methods: {
    debounceCheckPhone: _.debounce(function () {
      this.CheckPhone()
    }, 500),
    isMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        if (window.innerWidth >= 768) {
          return 500
        }
        return 320
      } else {
        return 500
      }
    },
    login() {
      if (this.query.phone === '' || this.errorPhone) {
        this.checkValidate = true
        return
      }
      localStorage.setItem('name', this.query.name)
      localStorage.setItem('phone', this.query.phone)
      localStorage.setItem('classroom', this.query.classroom)
      location.reload();
    },
    history() {
      this.is_history = !this.is_history
    },
    logout() {
      localStorage.clear();
      location.reload();
    },
    async startSpin() {
      if (this.is_login) {
        if (this.checkDisable) {
          return
        }
        this.checkDisable = true
        let phone = localStorage.phone ?? '';
        let class_id = localStorage.classroom ?? '';
        // Ensure that spinning can't be clicked again while already running.
        if (this.wheelSpinning === false) {
          // Based on the power level selected adjust the number of spins for the wheel, the more times is has
          // to rotate with the duration of the animation the quicker the wheel spins.
          this.resetWheel();
          this.image_url = ''
          this.theWheel.animation.spins = 10;

          // Disable the spin button so can't click again while wheel is spinning.
          // Important thing is to set the stopAngle of the animation before stating the spin.
          let form = new FormData();
          form.append('phone', phone);
          form.append('spin_reward_program_classroom_id', class_id);
          form.append('spin_reward_program_id', this.idProgram);
          const response = await fetch(`${URL_API_EDUTALK}/${GET_GIFT}`, {
            method: "POST",
            body: form,
          })
          const gift = await response.json();
          let id = gift?.data?.gift_id ?? -1
          let index = this.listGift.findIndex((gift) => gift.id === id)
          this.index = index
          this.image_url = gift?.data?.url ?? ''
          this.checkDisable = false
          if (!gift.error) {
            this.theWheel.animation.stopAngle = this.theWheel.getRandomForSegment(index + 1);
            // Begin the spin animation by calling startAnimation on the wheel object.
            this.theWheel.startAnimation();
            // Set to true so that power can't be changed and spin button re-enabled during
            // the current animation. The user will have to reset before spinning again.
            this.wheelSpinning = true;
          } else {
            this.$notify({
              title: 'Cảnh báo',
              message: gift.message,
              type: 'warning',
              offset: 100
            });
          }

        }
      } else {
        this.dialogLogin = true;
      }
    },
    resetWheel() {
      this.theWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
      this.theWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
      this.theWheel.draw();                // Call draw to render changes to the wheel.
      this.wheelSpinning = false;          // Reset too false to power buttons and spin can be clicked again.
    },
    async alertPrize(indicatedSegment) {
      //Trả kết quả
      this.wheelSpinning = false;
      this.centerDialogVisible = true;
      await this.getMyGift()
      await this.getHistoryGift()
    },
    playSound() {
      // Stop and rewind the sound if it already happens to be playing.
      this.audio.pause();
      this.audio.currentTime = 0;
      this.audio.play();
    },
    async CheckPhone() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(async () => {
        const response = await fetch(`${URL_API_EDUTALK}/${CHECK_PHONE_USER}?phone=${this.query.phone}`);
        let data = await response.json();
        this.errorPhone = data.error
        if (!data.error) {
          const res = await fetch(`${URL_API_EDUTALK}/${GET_NAME_USER}?phone=${this.query.phone}`);
          const response = await res.json();
          if (!response.error) {
            this.query.name = response.data?.name
            this.disabledSubmit = false
          } else {
            this.$notify({
              title: 'Cảnh báo',
              message: response.message,
              type: 'warning',
              offset: 100
            });
          }
        } else {
          this.$notify({
            title: 'Cảnh báo',
            message: data.message,
            type: 'warning',
            offset: 100
          });
        }
      }, 800);

    },
    async getHistoryGift() {
      const response = await fetch(`${URL_API_EDUTALK}/${GET_HISTORY_GIFT}`);
      let data = await response.json();
      this.dataHistory = data?.data?.data?.map((informationGift) => {
        return {
          id: informationGift?.id,
          name: informationGift?.name,
          phone: '*******' + informationGift?.phone.slice(7, 10),
          gif: informationGift?.spin_gift?.name,
          time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY')

        }
      })
    },
    async getMyGift() {
      const response = await fetch(`${URL_API_EDUTALK}/${GET_MY_GIFT}?phone=${localStorage.getItem('phone')}`);
      let data = await response.json();
      this.dataGift = data?.data?.data?.map((informationGift) => {
        return {
          id: informationGift.id,
          classroom: informationGift?.classroom?.name,
          gift: informationGift?.spin_gift?.name,
          time: moment(informationGift?.time).format('HH:mm DD-MM-YYYY')
        }
      })
    },
  }
}
</script>

<style>
.elementor-element {
  padding: 0 !important;
}

div[data-elementor-type="wp-page"] .elementor-element > .e-con-inner {
  max-width: unset;
}

.el-notification.right {
  z-index: 999999 !important;
}

.el-dialog {
  border-radius: 12px !important;
}

.el-notification .el-notification__title {
  font-size: 16px !important;
}

body table td,
table th {
  padding: unset !important;
  border: unset;
}

tr th {
  border: unset !important;
}
</style>
